import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  margin: 8px 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  margin-top: 36px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;\n  row-gap: 20px;\n  width: 100%;\n\n  a {\n    border: 1px solid #a6a6a6;\n    border-radius: 7px;\n    background: #0c0d10;\n    mix-blend-mode: normal;\n    img {\n      border-radius: 7px;\n    }\n  }\n  ",
        " {\n    display: flex;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 30px;\n  text-align: center;\n  letter-spacing: 0.001em;\n  color: #beb7b7;\n  width: 300px;\n  span {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 30px;\n    text-align: center;\n    letter-spacing: 0.001em;\n    color: #beb7b7;\n    font-weight: 700;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin-bottom: 45px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 20px;\n  row-gap: 20px;\n  width: 100%;\n  max-width: 1320px;\n  margin: 0 auto;\n  align-items: flex-start;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { vars } from "@pancakeswap/ui/css/vars.css";
import React from "react";
import styled from "styled-components";
import { Flex } from "../Box";
import { Text } from "../Text";
import { Link } from "../Link";
import { StyledFooter, StyledList, StyledListItem } from "./styles";
import { useMatchBreakpoints } from "@pancakeswap/uikit";
import Image from "next/image";
var FooterItem = styled.div.withConfig({
    componentId: "sc-c976c8c9-0"
})(_templateObject());
var TextLink = styled(Text).withConfig({
    componentId: "sc-c976c8c9-1"
})(_templateObject1());
var ListImgButton = styled.div.withConfig({
    componentId: "sc-c976c8c9-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledTitle = styled(Text).withConfig({
    componentId: "sc-c976c8c9-3"
})(_templateObject3());
var BlockDownload = styled.div.withConfig({
    componentId: "sc-c976c8c9-4"
})(_templateObject4());
var BlockListItem = styled.div.withConfig({
    componentId: "sc-c976c8c9-5"
})(_templateObject5());
var MenuItem = function(_param) {
    var items = _param.items, isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, cakePriceUsd = _param.cakePriceUsd, buyCakeLabel = _param.buyCakeLabel, props = _object_without_properties(_param, [
        "items",
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang",
        "cakePriceUsd",
        "buyCakeLabel"
    ]);
    var ref = useMatchBreakpoints(), isMobile = ref.isMobile, isTablet = ref.isTablet;
    return /*#__PURE__*/ _jsx(StyledFooter, _object_spread_props(_object_spread({
        "data-theme": "dark",
        p: [
            "40px 16px",
            null,
            "56px 40px 32px 40px"
        ]
    }, props), {
        children: /*#__PURE__*/ _jsxs(BlockListItem, {
            children: [
                /*#__PURE__*/ _jsx("img", {
                    src: "/images/V3/Logo.png"
                }),
                items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                    var ref;
                    /*#__PURE__*/ return _jsxs(StyledList, {
                        children: [
                            /*#__PURE__*/ _jsx(StyledListItem, {
                                children: item.label
                            }),
                            (ref = item.items) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                var label = param.label, href = param.href, image = param.image, _isHighlighted = param.isHighlighted, isHighlighted = _isHighlighted === void 0 ? false : _isHighlighted, border = param.border;
                                return /*#__PURE__*/ _jsxs(FooterItem, {
                                    children: [
                                        image && (border ? /*#__PURE__*/ _jsx("img", {
                                            src: image,
                                            style: {
                                                marginRight: 12,
                                                width: 24,
                                                background: "#3b4858",
                                                borderRadius: "50%",
                                                fill: "black"
                                            }
                                        }) : /*#__PURE__*/ _jsx("img", {
                                            src: image,
                                            style: {
                                                marginRight: 12,
                                                width: 24
                                            }
                                        })),
                                        href ? /*#__PURE__*/ _jsx("div", {
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                "data-theme": "dark",
                                                href: href,
                                                target: item.label === "Home" ? "" : "_blank",
                                                rel: "noreferrer noopener",
                                                color: isHighlighted ? vars.colors.warning : "text",
                                                bold: false,
                                                children: /*#__PURE__*/ _jsx(TextLink, {
                                                    children: label
                                                })
                                            })
                                        }, href) : /*#__PURE__*/ _jsx(TextLink, {
                                            children: label
                                        })
                                    ]
                                }, href);
                            })
                        ]
                    }, index);
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        width: "100%",
                        height: "2px",
                        backgroundColor: " rgba(255, 255, 255, 0.10)"
                    }
                }),
                /*#__PURE__*/ _jsxs(Flex, {
                    style: {
                        width: "100%",
                        justifyContent: "space-between",
                        flexDirection: isMobile ? "column-reverse" : "row",
                        gap: "16px"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            style: {
                                color: "var(--greyscale-grey-scale-text-seconday, #ADABB2)",
                                fontSize: "18px",
                                fontStyle: "normal",
                                fontWeight: "400",
                                lineHeight: "28px"
                            },
                            children: "\xa9 2023 Trendydefi. All rights reserved."
                        }),
                        /*#__PURE__*/ _jsxs(Flex, {
                            style: {
                                gap: "32px"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Link, {
                                    href: "https://github.com/trendydefi",
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        src: "/images/githubV3.png",
                                        width: 35,
                                        height: 35,
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    href: "https://trendydefi.medium.com/",
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        src: "/images/Community.png",
                                        width: 35,
                                        height: 35,
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    href: "https://www.youtube.com/@trendydefi",
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        src: "/images/youtube.png",
                                        width: 35,
                                        height: 35,
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
export default MenuItem;
